<template>
  <div class="__UsageSideList">
    <!-- Usage Type Selector -->
    <UsageTypeSelector :active="active" />

    <!--Resource List-->
    <router-view name="side_list" @click="onClickItem" />
  </div>
</template>

<script>
import UsageTypeSelector from '@/pages/UsageReport/SideList/UsageTypeSelector';
import { mapMutations } from 'vuex';

export default {
  name: 'SideList',
  components: { UsageTypeSelector },
  computed: {
    active() {
      return this.$route.meta.group_by;
    },
  },
  methods: {
    ...mapMutations('usageReports', ['updateId']),

    onClickItem(id) {
      this.$emit('click');

      this.updateId(id);
      // console.log("ID in Index: ", id)
    },
  },
};
</script>

<style lang="scss" scoped>
.__UsageSideList {
  width: 240px;
  min-width: 240px;
  max-width: 320px;

  padding-top: $space-md;

  padding-left: $space-md;
  margin-left: -8px;
  height: calc(100vh - 60px);
  overflow: auto;

  padding-right: $space-md;
  margin-right: $space-xs;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

@media (min-width: $md) {
  .__UsageSideList {
    width: 300px;
  }
}
@media (min-width: $lg) {
  .__UsageSideList {
    width: 320px;
  }
}
</style>
